const encoder = new TextEncoder()

/**
 * Converts a string to a Uint8Array using UTF-8 encoding.
 *
 * @param value - The string to convert
 * @returns A Uint8Array containing the UTF-8 encoded bytes
 *
 * @example
 * ```ts
 * import { StringToUInt8, UInt8Hash } from "@pdfking/tfunc"
 *
 * StringToUInt8("Hello") // Uint8Array([72, 101, 108, 108, 111])
 *
 * // Use for hashing
 * UInt8Hash([StringToUInt8("my-data")])
 * ```
 */
// `Uint8Array<ArrayBuffer>` rather than the default `ArrayBufferLike`: the
// encoder allocates the buffer, so it is never shared — which is what lets the
// result be passed straight to a Response or any other BodyInit.
export const StringToUInt8 = (value: string): Uint8Array<ArrayBuffer> => encoder.encode(value)
